import React from 'react'
import { usePutRequest } from '../../../hooks/request'
import { TOTAL_EXPENSE_CATEGORY_DETAIL } from '../../../urls'
import TotalExpenseCategoryForm from './TotalExpenseCategoryForm'

export default function TotalExpenseCategoryUpdate({ onCancel, onSuccess, item }) {
    const brandUpdate = usePutRequest({ url: TOTAL_EXPENSE_CATEGORY_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить</b>
            </h1>
            <TotalExpenseCategoryForm loading={brandUpdate.loading} initialValues={item} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
